import _classCallCheck from "/Users/spana/SHEIN/shineout/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/Users/spana/SHEIN/shineout/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/createClass";
import _assertThisInitialized from "/Users/spana/SHEIN/shineout/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/assertThisInitialized";
import _inherits from "/Users/spana/SHEIN/shineout/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/inherits";
import _possibleConstructorReturn from "/Users/spana/SHEIN/shineout/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "/Users/spana/SHEIN/shineout/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/getPrototypeOf";

function _createSuper2(Derived) {
  function isNativeReflectConstruct() {
    if (typeof Reflect === "undefined" || !Reflect.construct) return false;
    if (Reflect.construct.sham) return false;
    if (typeof Proxy === "function") return true;

    try {
      Date.prototype.toString.call(Reflect.construct(Date, [], function () {}));
      return true;
    } catch (e) {
      return false;
    }
  }

  return function () {
    var Super = _getPrototypeOf(Derived),
        result;

    if (isNativeReflectConstruct()) {
      var NewTarget = _getPrototypeOf(this).constructor;

      result = Reflect.construct(Super, arguments, NewTarget);
    } else {
      result = Super.apply(this, arguments);
    }

    return _possibleConstructorReturn(this, result);
  };
}

import React, { PureComponent } from 'react';
import classnames from 'classnames';
import { getUidStr } from '../utils/uid';
import { tableClass } from './styles';
import Sorter from './Sorter';
import CheckboxAll from './CheckboxAll';
import { getParent } from '../utils/dom/element';
import { isNumber } from '../utils/is';
var cacheGroup = new Map();
var MIN_RESIZABLE_WIDTH = 20;

var Thead =
/*#__PURE__*/
function (_PureComponent) {
  _inherits(Thead, _PureComponent);

  var _super = _createSuper2(Thead);

  function Thead(props) {
    var _this;

    _classCallCheck(this, Thead);

    _this = _super.call(this, props);
    _this.handleMouseDown = void 0;
    _this.handleMouseMove = void 0;
    _this.handleMouseUp = void 0;
    _this.resizingTh = void 0;
    _this.resizingTable = void 0;
    _this.columnLevel = void 0;
    _this.resizingIndex = void 0;
    _this.resizingCol = void 0;
    _this.lastX = void 0;
    _this.rightBorderRecord = void 0;
    _this.handleMouseDown = _this.handleResize.bind(_assertThisInitialized(_this), 'mousedown');
    _this.handleMouseMove = _this.handleResize.bind(_assertThisInitialized(_this), 'mousemove');
    _this.handleMouseUp = _this.handleResize.bind(_assertThisInitialized(_this), 'mouseup');
    return _this;
  }

  _createClass(Thead, [{
    key: "setColumns",
    value: function setColumns(columns, col, level) {
      var index = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : 0;

      if (!col.group) {
        columns.push(col);
        return 1;
      }

      if (level > this.columnLevel) this.columnLevel = level;
      var g = Array.isArray(col.group) ? col.group : [col.group];
      var last = columns[columns.length - 1];

      if (!g[level]) {
        columns.push(col);
        return 1;
      }

      var colSpan = 0;

      if (last && last.name === g[level]) {
        colSpan = this.setColumns(last.columns, col, level + 1, index);
        last.colSpan += colSpan;
        if (col.fixed) last.fixed = col.fixed;
        if (col.lastFixed) last.lastFixed = true;
      } else {
        var sub = [];
        colSpan = this.setColumns(sub, col, level + 1, index);
        var group = g[level];
        columns.push({
          name: g[level],
          key: typeof g[level] === 'string' ? "".concat(index, "-").concat(g[level]) : cacheGroup.get(group) || cacheGroup.set(group, getUidStr()).get(group),
          colSpan: colSpan,
          level: level,
          fixed: col.fixed,
          firstFixed: col.firstFixed,
          columns: sub
        });
      }

      return colSpan;
    }
  }, {
    key: "resizeColgroup",
    value: function resizeColgroup(deltaX) {
      var columns = this.props.columns;
      var item = columns[this.resizingIndex];
      var minWidth = item.minWidth,
          maxWidth = item.maxWidth;
      var oWidth = parseInt(this.resizingCol.style.width, 10);

      if (Number.isNaN(oWidth) || oWidth === 0) {
        oWidth = this.resizingTh.getBoundingClientRect().width;
      }

      var w = oWidth + deltaX;

      if (isNumber(minWidth)) {
        w = Math.max(w, minWidth);
      } else {
        w = Math.max(w, MIN_RESIZABLE_WIDTH);
      }

      if (isNumber(maxWidth)) {
        w = Math.min(w, maxWidth);
      }

      this.resizingCol.style.width = "".concat(w, "px");
    }
  }, {
    key: "handleResize",
    value: function handleResize(type, e) {
      if (type === 'mousedown') {
        var target = e.target;
        this.resizingTh = getParent(target, 'th');
        this.resizingTable = getParent(target, 'table');
        var thList = getParent(target, 'tr').children;
        var indexInTr = [].indexOf.call(thList, this.resizingTh);
        this.resizingIndex = [].slice.call(thList, 0, indexInTr).reduce(function (total, th) {
          var count = Number(th.getAttribute('colspan')) || 1;
          return total + count;
        }, 0);
        this.resizingCol = this.resizingTable.querySelectorAll('col')[this.resizingIndex];
        this.resizingTable.classList.add(tableClass('resizing'));
        this.resizingTh.classList.add(tableClass('resizing-item'));
        document.addEventListener('mousemove', this.handleMouseMove);
        document.addEventListener('mouseup', this.handleMouseUp);
      } else if (type === 'mousemove') {
        var x = e.clientX;

        if (typeof this.lastX === 'number') {
          var deltaX = x - this.lastX;
          this.resizeColgroup(deltaX);
        }

        this.lastX = x;
      } else if (type === 'mouseup') {
        var _this$props = this.props,
            onColChange = _this$props.onColChange,
            colgroup = _this$props.colgroup;
        document.removeEventListener('mousemove', this.handleMouseMove);
        document.removeEventListener('mouseup', this.handleMouseUp);
        this.resizingTable.classList.remove(tableClass('resizing'));
        this.resizingTh.classList.remove(tableClass('resizing-item'));
        this.lastX = undefined;
        if (onColChange) onColChange(this.resizingIndex, parseInt(this.resizingCol.style.width, 10), colgroup);
      }
    }
  }, {
    key: "createTh",
    value: function createTh(trs, col, level) {
      var _this2 = this;

      var columnResizable = this.props.columnResizable;
      var colTemp = col;
      var colTemp2 = col;
      var fixed = [];
      if (col.fixed) fixed.push("fixed-".concat(col.fixed));
      if (col.firstFixed) fixed.push('fixed-first');
      if (col.lastFixed) fixed.push('fixed-last');
      var _this$props2 = this.props,
          sorter = _this$props2.sorter,
          onSortChange = _this$props2.onSortChange,
          data = _this$props2.data,
          datum = _this$props2.datum,
          showSelectAll = _this$props2.showSelectAll,
          disabled = _this$props2.disabled,
          treeColumnsName = _this$props2.treeColumnsName,
          treeCheckAll = _this$props2.treeCheckAll;
      var isEmpty = !(data && data.length);
      var align = colTemp.align && "align-".concat(colTemp.align);
      var ignoreBorderRight = this.rightBorderRecord[col.key] && 'ignore-right-border';
      var resize = level === 0 && !isEmpty && columnResizable && col.columnResizable !== false ?
      /*#__PURE__*/
      React.createElement("span", {
        onMouseDown: this.handleMouseDown,
        className: tableClass('resize-spanner')
      }) : null;

      if (colTemp.title) {
        trs[level].push(
        /*#__PURE__*/
        React.createElement("th", {
          className: classnames(tableClass.apply(void 0, [level > 0 && 'condensed', align, ignoreBorderRight].concat(fixed)), col.className),
          rowSpan: this.columnLevel - level + 1,
          key: col.key
        },
        /*#__PURE__*/
        React.createElement("div", {
          className: tableClass(colTemp.sorter && 'has-sorter')
        },
        /*#__PURE__*/
        React.createElement("span", null, typeof colTemp.title === 'function' ? colTemp.title(data) : colTemp.title), colTemp.sorter &&
        /*#__PURE__*/
        React.createElement(Sorter, Object.assign({}, colTemp, {
          sorter: colTemp.sorter,
          current: sorter,
          keyStr: col.key,
          onChange: onSortChange,
          renderSorter: this.props.renderSorter
        })), resize)));
        return;
      }

      if (colTemp.type === 'checkbox') {
        trs[level].push(
        /*#__PURE__*/
        React.createElement("th", {
          key: "checkbox",
          rowSpan: trs.length,
          className: classnames(tableClass.apply(void 0, ['checkbox'].concat(fixed)), colTemp.className)
        }, showSelectAll &&
        /*#__PURE__*/
        React.createElement(CheckboxAll, {
          disabled: disabled === true,
          data: data,
          datum: datum,
          treeColumnsName: treeCheckAll ? treeColumnsName : undefined,
          col: col
        })));
        return;
      }

      var style = typeof colTemp2.name === 'string' ? undefined : {
        padding: 0
      };
      trs[level].push(
      /*#__PURE__*/
      React.createElement("th", {
        className: classnames(tableClass.apply(void 0, ['center', 'condensed', ignoreBorderRight].concat(fixed)), col.className),
        colSpan: colTemp2.colSpan,
        key: col.key,
        style: style
      }, colTemp2.name, resize));

      if (colTemp2.columns) {
        colTemp2.columns.forEach(function (c) {
          return _this2.createTh(trs, c, level + 1);
        });
      }
    }
  }, {
    key: "ignoreRightBorder",
    value: function ignoreRightBorder(column) {
      var columnGroup = column;
      this.rightBorderRecord[column.key] = true;
      if (columnGroup.columns) this.ignoreRightBorder(columnGroup.columns[columnGroup.columns.length - 1]);
    }
  }, {
    key: "formatColumns",
    value: function formatColumns() {
      var _this3 = this;

      this.columnLevel = 0;
      var columns = [];
      this.props.columns.forEach(function (col, index) {
        _this3.setColumns(columns, col, 0, index);
      });
      this.rightBorderRecord = {};

      if (columns.length > 0 && this.props.bordered) {
        this.ignoreRightBorder(columns[columns.length - 1]);
      }

      return columns;
    }
  }, {
    key: "formatTrs",
    value: function formatTrs() {
      var _this4 = this;

      var columns = this.formatColumns();
      var trs = [];

      for (var i = 0; i <= this.columnLevel; i++) {
        trs.push([]);
      }

      columns.forEach(function (col) {
        return _this4.createTh(trs, col, 0);
      });
      return trs;
    }
  }, {
    key: "render",
    value: function render() {
      var trs = this.formatTrs();
      return (
        /*#__PURE__*/
        React.createElement("thead", null, trs.map(function (tr, i) {
          return (
            /*#__PURE__*/
            React.createElement("tr", {
              key: i
            }, tr)
          );
        }))
      );
    }
  }]);

  return Thead;
}(PureComponent);

Thead.defaultProps = {
  showSelectAll: true
};
export default Thead;